import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { updateElementCacheByCalloutAction } from 'store/actions/element-cache-actions';
import { createOrUpdateElementWorkpaperRequest } from 'api/workpaper-api';
import { getElementWorkpapersAndUpdateElementCacheWithParameters } from 'store/actions/common/element-panel-actions';
import { fetchWorkpaperListForRevisionWithoutLoading } from 'store/actions/workpaper-toolkit-list-actions';
import CreateWorkpaperModal from 'components/feature/element-panel/workpaper-panel/create-work-paper-modal';

const CreateWorkPaper = ({ show, setShow, onCloseModal, elementDetails }) => {
  const dispatch = useDispatch();
  const socketHasBeenDisconnected = useSelector(
    (state) => state.sockets.statementSocket.socketHasBeenDisconnected,
  );
  const revision = useSelector((state) => state.data.revision);

  const onClose = () => {
    setShow(false);
    if (onCloseModal) {
      onCloseModal();
    }
  };

  const onCreate = async ({ workpaperModel }) => {
    const revisionId = revision.id;
    const { id, sectionId } = elementDetails;
    await createOrUpdateElementWorkpaperRequest({ workpaperModel });
    dispatch(
      updateElementCacheByCalloutAction({
        elementIds: [id],
        showCallout: true,
      }),
    );
    onClose();
    if (socketHasBeenDisconnected) {
      await dispatch(
        getElementWorkpapersAndUpdateElementCacheWithParameters({
          elementId: id,
          sectionId: sectionId,
        }),
      );
      dispatch(fetchWorkpaperListForRevisionWithoutLoading({ revisionId }));
    }
  };

  return (
    <div>
      {show && (
        <CreateWorkpaperModal
          onClose={onClose}
          onCreate={onCreate}
          elementDetails={elementDetails}
        />
      )}
    </div>
  );
};

export default CreateWorkPaper;

CreateWorkPaper.propTypes = {
  // Property to control the visibility of the modal
  show: PropTypes.bool.isRequired,
  // Function to control the visibility of the modal
  setShow: PropTypes.func.isRequired,
  // Function to handle closing the modal
  onCloseModal: PropTypes.func.isRequired,
  // Details of the element for which the workpaper is being created
  elementDetails: PropTypes.object.isRequired,
};
